import { Injectable } from '@angular/core';
import { Firestore, FirestoreDataConverter } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { DEFAULT_DATE_PROPERTIES, defaultFirestoreConverter, setPropertyDate } from '../../core/db/firestore.helper';
import { HolidayYear } from './holiday.models';

const holidayFirestoreConverter = (
  dateProperties: string[] = DEFAULT_DATE_PROPERTIES
): FirestoreDataConverter<HolidayYear> => ({
  toFirestore: defaultFirestoreConverter<HolidayYear>(dateProperties).toFirestore,
  fromFirestore: (...args) => {
    const data = defaultFirestoreConverter<HolidayYear>(dateProperties).fromFirestore(...args);
    data.holidays?.forEach(e => setPropertyDate(e, 'date'));
    return data;
  },
});


/**
 * Holiday Firestore data-access service.
 * Extends {@link FirestoreBase} to reuse generic CRUD and query helpers.
 * Use inherited methods such as `get$`, `getOneWhere$`, `create`, `upsert`, and `update`
 * from higher layers (`holiday.service`) unless a holiday-specific query is required.
 */
@Injectable({ providedIn: 'root' })
export class HolidayDbService extends FirestoreBase<HolidayYear> {
  constructor(firestore: Firestore) {
    super(
      'holidays',
      firestore,
      { firestoreConverter: holidayFirestoreConverter() }
    );
  }
}
